var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDeth3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#1F2023"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5424 3.67906L12.7915 7.932C13.1066 8.2484 13.1066 8.76025 12.7915 9.07665L8.5424 13.3296C8.2271 13.6462 7.71485 13.6464 7.3988 13.3306C7.39865 13.3304 7.39845 13.3303 7.3988 13.3296L3.14964 9.07665C2.83456 8.76025 2.83456 8.2484 3.14964 7.932L7.3988 3.67906C7.7141 3.36247 8.2263 3.36224 8.5424 3.67803C8.54255 3.6782 8.5427 3.67837 8.5424 3.67906Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42265 3.70429C7.71915 3.40656 8.1975 3.4008 8.5015 3.68682L8.50135 3.68715L8.5185 3.70433L12.7676 7.95727C13.0696 8.26047 13.0696 8.75102 12.7676 9.05427L8.5185 13.3072H8.51845C8.22195 13.605 7.7436 13.6107 7.4396 13.3247L7.4398 13.3244L7.4226 13.3072L3.1735 9.05427C2.87152 8.75102 2.87153 8.26047 3.1735 7.95727L7.4226 3.70433L7.42265 3.70429ZM7.4226 13.3082C7.4225 13.3081 7.4229 13.3084 7.42355 13.3092C7.42325 13.3089 7.42295 13.3085 7.4226 13.3082ZM8.51755 3.70238C8.5179 3.7027 8.5182 3.70301 8.51855 3.70333C8.51865 3.70343 8.51825 3.7031 8.51755 3.70238Z",
    fill: "#00ED76",
    stroke: "black",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66211 8.77344L7.98456 10.1658V12.1076L5.66211 8.77344Z",
    fill: "#78A7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3068 8.77344L7.98438 10.1658V12.1076L10.3068 8.77344Z",
    fill: "#D1ADFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66211 8.30588L7.98456 9.66518V7.22266L5.66211 8.30588Z",
    fill: "#78A7FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3068 8.30588L7.98438 9.66518V7.22266L10.3068 8.30588Z",
    fill: "#D1ADFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66211 8.31057L7.98456 7.22711V4.43359L5.66211 8.31057Z",
    fill: "#D1ADFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3068 8.31057L7.98438 7.22711V4.43359L10.3068 8.31057Z",
    fill: "#89FEF7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.232 8.76235C10.2657 8.7421 10.3028 8.7789 10.2868 8.81185L10.2835 8.8176L8.00224 12.1035C7.98829 12.1236 7.96014 12.1254 7.94359 12.109L7.93904 12.1035L5.65784 8.8176C5.63543 8.78535 5.66944 8.74565 5.70328 8.75935L5.70925 8.76235L7.97059 10.1227L10.232 8.76235ZM10.1174 8.92135L7.99044 10.2009C7.98029 10.207 7.96799 10.2081 7.95714 10.204L7.95084 10.2009L5.82378 8.92135L7.97059 12.0137L10.1174 8.92135ZM7.93759 4.46797C7.95134 4.44505 7.98284 4.44314 7.99949 4.46224L8.00369 4.46797L10.2849 8.27855C10.2936 8.2931 10.2916 8.30875 10.2837 8.32025C10.2942 8.33565 10.2925 8.3579 10.2775 8.37105L10.2713 8.3756L7.99009 9.7125C7.98009 9.71835 7.96809 9.71935 7.95744 9.71545L7.95124 9.7125L5.67001 8.3756C5.64951 8.36355 5.64574 8.33765 5.65764 8.32025C5.65191 8.31195 5.64924 8.3015 5.65154 8.2908L5.65353 8.28435L5.65643 8.27855L7.93759 4.46797ZM7.97059 7.31934L5.77238 8.346L7.97059 9.63435L10.1688 8.346L7.97059 7.31934ZM7.97069 4.56285L5.78725 8.2101L7.95439 7.19849C7.96054 7.19563 7.96734 7.19445 7.97399 7.19506L7.98054 7.19621L7.98689 7.19849L10.154 8.2102L7.97069 4.56285Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeth3);
export default __webpack_public_path__ + "static/media/icon-deth3.5c7e5086.svg";
export { ForwardRef as ReactComponent };